const searchCondition = {
  state: {
    getOrder: {
      orderType: 0,
      department: 0,
      preset: 20,
      qcStatus: [],
      durationStart: new Date(1640966400000),
      durationEnd: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      inputSearch: ''
    },
    payOrder: {
      orderType: 0,
      department: 0,
      preset: 20,
      qcStatus: [],
      durationStart: new Date(1640966400000),
      durationEnd: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      inputSearch: ''
    },
    magOrder: {
      orderType: 0,
      department: 0,
      preset: 20,
      qcStatus: [],
      durationStart: new Date(1640966400000),
      durationEnd: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      inputSearch: ''
    },
    reportOrder: {
      orderType: 0,
      department: 0,
      preset: 20,
      qcStatus: [],
      durationStart: new Date(1640966400000),
      durationEnd: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      inputSearch: ''
    },
    allOrder: {
      orderType: 0,
      department: 0,
      preset: 20,
      qcStatus: [],
      durationStart: new Date(1640966400000),
      durationEnd: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      inputSearch: ''
    },
    refundOrder:{
      orderType: 0,
      department: 0,
      preset: 20,
      qcStatus: [],
      durationStart: new Date(1640966400000),
      durationEnd: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      inputSearch: ''
    },
    classicalOrder:{
      orderType: 0,
      department: 0,
      preset: 20,
      qcStatus: [],
      durationStart: new Date(1640966400000),
      durationEnd: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      inputSearch: ''
    }
  },
  mutations: {
    changeOrderType (state, orderType) {
      state.getOrder.orderType = orderType
    },
    changeDepartment (state, department) {
      state.getOrder.department = department
    },
    changePreset (state, preset) {
      state.getOrder.preset = preset
    },
    changeQCStatus (state, qcStatus) {
      state.getOrder.qcStatus = qcStatus
    },
    changeDurationStart (state, durationStart) {
      state.getOrder.durationStart = durationStart
    },
    changeDurationEnd (state, durationEnd) {
      state.getOrder.durationEnd = durationEnd
    },
    changeInputSearch (state, inputSearch) {
      state.getOrder.inputSearch = inputSearch
    },
    changeMagOrderType (state, orderType) {
      state.magOrder.orderType = orderType
    },
    changeMagDepartment (state, department) {
      state.magOrder.department = department
    },
    changeMagPreset (state, preset) {
      state.magOrder.preset = preset
    },
    changeMagQCStatus (state, qcStatus) {
      state.magOrder.qcStatus = qcStatus
    },
    changeMagDurationStart (state, durationStart) {
      state.magOrder.durationStart = durationStart
    },
    changeMagDurationEnd (state, durationEnd) {
      state.magOrder.durationEnd = durationEnd
    },
    changeMagInputSearch (state, inputSearch) {
      state.magOrder.inputSearch = inputSearch
    },
    changeReportOrderType (state, orderType) {
      state.reportOrder.orderType = orderType
    },
    changeReportDepartment (state, department) {
      state.reportOrder.department = department
    },
    changeReportPreset (state, preset) {
      state.reportOrder.preset = preset
    },
    changeReportQCStatus (state, qcStatus) {
      state.reportOrder.qcStatus = qcStatus
    },
    changeReportDurationStart (state, durationStart) {
      state.reportOrder.durationStart = durationStart
    },
    changeReportDurationEnd (state, durationEnd) {
      state.reportOrder.durationEnd = durationEnd
    },
    changeReportInputSearch (state, inputSearch) {
      state.reportOrder.inputSearch = inputSearch
    },
    changeAllOrderType (state, orderType) {
      state.allOrder.orderType = orderType
    },
    changeAllDepartment (state, department) {
      state.allOrder.department = department
    },
    changeAllPreset (state, preset) {
      state.allOrder.preset = preset
    },
    changeAllQCStatus (state, qcStatus) {
      state.allOrder.qcStatus = qcStatus
    },
    changeAllDurationStart (state, durationStart) {
      state.allOrder.durationStart = durationStart
    },
    changeAllDurationEnd (state, durationEnd) {
      state.allOrder.durationEnd = durationEnd
    },
    changeAllInputSearch (state, inputSearch) {
      state.allOrder.inputSearch = inputSearch
    },
    changePayOrderType (state, orderType) {
      state.payOrder.orderType = orderType
    },
    changePayDepartment (state, department) {
      state.payOrder.department = department
    },
    changePayPreset (state, preset) {
      state.payOrder.preset = preset
    },
    changePayQCStatus (state, qcStatus) {
      state.payOrder.qcStatus = qcStatus
    },
    changePayDurationStart (state, durationStart) {
      state.payOrder.durationStart = durationStart
    },
    changePayDurationEnd (state, durationEnd) {
      state.payOrder.durationEnd = durationEnd
    },
    changePayInputSearch (state, inputSearch) {
      state.payOrder.inputSearch = inputSearch
    },
    changeRefundOrderType (state, orderType) {
      state.refundOrder.orderType = orderType
    },
    changeRefundDepartment (state, department) {
      state.refundOrder.department = department
    },
    changeRefundPreset (state, preset) {
      state.refundOrder.preset = preset
    },
    changeRefundQCStatus (state, qcStatus) {
      state.refundOrder.qcStatus = qcStatus
    },
    changeRefundDurationStart (state, durationStart) {
      state.refundOrder.durationStart = durationStart
    },
    changeRefundDurationEnd (state, durationEnd) {
      state.refundOrder.durationEnd = durationEnd
    },
    changeRefundInputSearch (state, inputSearch) {
      state.refundOrder.inputSearch = inputSearch
    },
    changeClassicalOrderType (state, orderType) {
      state.classicalOrder.orderType = orderType
    },
    changeClassicalDepartment (state, department) {
      state.classicalOrder.department = department
    },
    changeClassicalPreset (state, preset) {
      state.classicalOrder.preset = preset
    },
    changeClassicalQCStatus (state, qcStatus) {
      state.classicalOrder.qcStatus = qcStatus
    },
    changeClassicalDurationStart (state, durationStart) {
      state.classicalOrder.durationStart = durationStart
    },
    changeClassicalDurationEnd (state, durationEnd) {
      state.classicalOrder.durationEnd = durationEnd
    },
    changeClassicalInputSearch (state, inputSearch) {
      state.classicalOrder.inputSearch = inputSearch
    }
  }
}

export default searchCondition



// WEBPACK FOOTER //
// ./src/store/modules/searchCondition.js